export const LAYOUT_REPORT_HOME = '/app/home'

export const LAYOUT_REPORT_PANEL = '/app/report/panel'

export const LAYOUT_REPORT_STATS_ROOT = '/app/report/stats'
export const LAYOUT_REPORT_STATS_JOBS_GENERAL = '/app/report/stats/jobs'
export const LAYOUT_REPORT_STATS_JOBS_PERIOD = (id) =>
  `/app/report/stats/jobs/${id}`
export const LAYOUT_REPORT_STATS_EVOLUTION_GENERAL =
  '/app/report/stats/evolution'

export const LAYOUT_REPORT_EXPORT_ROOT = '/app/report/export'
export const LAYOUT_REPORT_EXPORT_LIST = '/app/report/export/list'
export const LAYOUT_REPORT_EXPORT_NEW = '/app/report/export/new'
